// extracted by mini-css-extract-plugin
export default {"selected_item":"styles_selected_item__MwXUx","not_selected_item":"styles_not_selected_item__X0Rx2"};